// import { createTheme } from "@mui/material";



// export const theme = createTheme({
//   palette: {
//     primary: { main: `rgb(${cssVar("--color-primary")})` },
//   },
//   typography: {
//     allVariants: { color: `rgb(${cssVar("--color-dark-text")})` },
//   },
//   components: {
//     MuiSelect: {
//       styleOverrides: {
//         root: {
//           color: `rgb(${cssVar("--color-dark-text")})`,
//         },
//       },
//     },
//     MuiInputBase: {
//       styleOverrides: {
//         input: { 
//           color: `rgb(${cssVar("--color-dark-text")})` 
//         },
//         root: {
//           "& .MuiInput-underline:before": {
//             borderBottom: `1px solid rgb(${cssVar("--color-dark-text")})`, 
//           },
//           "& .MuiInput-underline:after": {
//             borderBottom: `2px solid rgb(${cssVar("--color-primary")})`, 
//           },
//         },
//       },
//     },
//     MuiStepper: {
//       styleOverrides: {
//         root: {
//           "& .MuiStepLabel-root.Mui-active": {
//             color: `rgb(${cssVar("--color-primary")})`,
//           },
//         },
//       },
//     },
//     MuiTabs: {
//       styleOverrides: {
//         root: {
//           "& .MuiTab-root.Mui-selected": {
//             color: `rgb(${cssVar("--color-primary")})`, 
//           },
//         },
//       },
//     },
//     MuiTab: {
//       styleOverrides: {
//         root: {
//           "&.Mui-selected": {
//             color: `rgb(${cssVar("--color-primary")})`, 
//           },
//         },
//       },
//     },
//   },
// });

import { createTheme } from "@mui/material";
const cssVar = (name: string) =>
  getComputedStyle(document.documentElement).getPropertyValue(name).trim();
export const createDynamicTheme = (primaryColor: string, textColor: string,themeSelColor:String) =>
  createTheme({
    palette: {
      primary: { main: primaryColor },
    },
    typography: {
          allVariants: { color: `rgb(${cssVar("--color-dark-text")})` },
        },
    components: {
      MuiSelect: {
        styleOverrides: {
          root: {
            color: textColor,
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          input: { 
            color: "black",
            "&::placeholder": {
              color: "black", 
              opacity: 1, 
            },
          },
          root: {
            "& .MuiInput-underline:before": {
              borderBottom: `1px solid ${primaryColor}`, 
            },
            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
              borderBottom: `1px solid ${primaryColor}`,
            },
            "& .MuiInput-underline:after": {
              borderBottom: `2px solid ${primaryColor}`, 
            },
          },
        },
      },
      MuiStepper: {
        styleOverrides: {
          root: {
            "& .MuiStepLabel-root.Mui-active": {
              color: primaryColor,
          },
          },
        },
      },

      MuiStepIcon: {
        styleOverrides: {
          root: {
            "&.Mui-active": {
              color: primaryColor, // Active circle background color
            },
            
          },
         
        },
      },
      MuiTabs: {
        styleOverrides: {
          root: {
            "& .MuiTab-root.Mui-selected": {
              color: themeSelColor,
            },
             "& .MuiStepLabel-label.Mui-active": {
              color: themeSelColor, 
            },
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            "&.Mui-selected": {
              color: primaryColor,
            },
          },
        },
      },
    },
  });
